export const USERS_GET_PENDING = 'USERS_GET_PENDING';
export const USERS_INFO = 'USERS_INFO';
